export default __webpack_public_path__ + "/dist/images/mail-share-icon.svg";